import months from './../../Shared/months.json';

export function usePreviewtoString(detail, lang, logo, width) {
    const recruitmentPrivacyPolicy = detail?.recruitmentPrivacyPolicy;
    const recruitmentIntroductionLawfulBasis =
        detail?.recruitmentIntroductionLawfulBasis;
    const recruitmentPersonalDataCollect =
        detail?.recruitmentPersonalDataCollect;
    const recruitmentReasonCollectedData =
        detail?.recruitmentReasonCollectedData;
    const recruitmentTransferPersonalData =
        detail?.recruitmentTransferPersonalData;
    const recruitmentRetainPersonalData = detail?.recruitmentRetainPersonalData;
    const recruitmentDataSubjectRight = detail?.recruitmentDataSubjectRight;
    const recruitmentPolicyChange = detail?.recruitmentPolicyChange;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    let date = '';
    if (recruitmentPrivacyPolicy?.updateDate) {
        const split = recruitmentPrivacyPolicy?.updateDate.split('/');
        const year = split[2].split(' ');
        const date_ = `_${split[0]}-${split[1]}-${year[0]}_`;
        date = date_;
    }

    const body = `
    <body style="word-break: break-word;">
        <center>
        ${
            logo &&
            `<img
            width="${width}" height="100"
        style="object-fit: cover;"
        src=${logo}
        alt="logo "/>`
        }</center>
        <center>
            <h3>
                ${
                    lang === 'TH'
                        ? recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyNameTh
                        : recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyNameEn
                }
            </h3>
        </center>
            <p className="text-left">
                ${
                    recruitmentIntroductionLawfulBasis?.recruitmentIntroductionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentIntroductionLawfulBasis?.recruitmentIntroductionContentTh ||
                              '-'
                            : recruitmentIntroductionLawfulBasis?.recruitmentIntroductionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisTitleTh
                            : recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisContentTh ||
                              '-'
                            : recruitmentIntroductionLawfulBasis?.recruitmentLawfulBasisContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentPersonalDataCollect?.recruitmentPersonalDataIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentPersonalDataCollect?.recruitmentPersonalDataTitleTh
                            : recruitmentPersonalDataCollect?.recruitmentPersonalDataTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
            ${
                recruitmentPersonalDataCollect?.recruitmentPersonalDataIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentPersonalDataCollect?.recruitmentPersonalDataContentTh ||
                          '-'
                        : recruitmentPersonalDataCollect?.recruitmentPersonalDataContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                recruitmentPersonalDataCollect?.recruitmentSourceIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentPersonalDataCollect?.recruitmentSourceTitleTh
                        : recruitmentPersonalDataCollect?.recruitmentSourceTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                recruitmentPersonalDataCollect?.recruitmentSourceIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentPersonalDataCollect?.recruitmentSourceContentTh ||
                          '-'
                        : recruitmentPersonalDataCollect?.recruitmentSourceContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                recruitmentReasonCollectedData?.recruitmentPurposeIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentReasonCollectedData?.recruitmentPurposeTitleTh
                        : recruitmentReasonCollectedData?.recruitmentPurposeTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                recruitmentReasonCollectedData?.recruitmentPurposeIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentReasonCollectedData?.recruitmentPurposeContentTh ||
                          '-'
                        : recruitmentReasonCollectedData?.recruitmentPurposeContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                recruitmentTransferPersonalData?.recruitmentDisclosureIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentTransferPersonalData?.recruitmentDisclosureTitleTh
                        : recruitmentTransferPersonalData?.recruitmentDisclosureTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                recruitmentTransferPersonalData?.recruitmentDisclosureIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentTransferPersonalData?.recruitmentDisclosureContentTh ||
                          '-'
                        : recruitmentTransferPersonalData?.recruitmentDisclosureContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                recruitmentTransferPersonalData?.recruitmentInternationalIsDisplay ===
                true
                    ? lang === 'TH'
                        ? recruitmentTransferPersonalData?.recruitmentInternationalTitleTh ||
                          '-'
                        : recruitmentTransferPersonalData?.recruitmentInternationalTitleEn ||
                          '-'
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentTransferPersonalData?.recruitmentInternationalIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentTransferPersonalData?.recruitmentInternationalContentTh ||
                              '-'
                            : recruitmentTransferPersonalData?.recruitmentInternationalContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentRetainPersonalData?.recruitmentRetentionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentRetainPersonalData?.recruitmentRetentionTitleTh
                            : recruitmentRetainPersonalData?.recruitmentRetentionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentRetainPersonalData?.recruitmentRetentionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentRetainPersonalData?.recruitmentRetentionContentTh ||
                              '-'
                            : recruitmentRetainPersonalData?.recruitmentRetentionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentRetainPersonalData?.recruitmentSecurityIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentRetainPersonalData?.recruitmentSecurityTitleTh
                            : recruitmentRetainPersonalData?.recruitmentSecurityTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentRetainPersonalData?.recruitmentSecurityIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentRetainPersonalData?.recruitmentSecurityContentTh ||
                              '-'
                            : recruitmentRetainPersonalData?.recruitmentSecurityContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentDataSubjectRight?.recruitmentDataSubjectRightIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentDataSubjectRight?.recruitmentDataSubjectRightTitleTh
                            : recruitmentDataSubjectRight?.recruitmentDataSubjectRightTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentDataSubjectRight?.recruitmentDataSubjectRightIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentDataSubjectRight?.recruitmentDataSubjectRightContentTh ||
                              '-'
                            : recruitmentDataSubjectRight?.recruitmentDataSubjectRightContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentPolicyChange?.recruitmentChangeIsDisplay === true
                        ? lang === 'TH'
                            ? recruitmentPolicyChange?.recruitmentChangeTitleTh
                            : recruitmentPolicyChange?.recruitmentChangeTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentPolicyChange?.recruitmentChangeIsDisplay === true
                        ? lang === 'TH'
                            ? recruitmentPolicyChange?.recruitmentChangeContentTh ||
                              '-'
                            : recruitmentPolicyChange?.recruitmentChangeContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentPolicyChange?.recruitmentDataControllerIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentPolicyChange?.recruitmentDataControllerTitleTh
                            : recruitmentPolicyChange?.recruitmentDataControllerTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentPolicyChange?.recruitmentDataControllerIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentPolicyChange?.recruitmentDataControllerContentTh ||
                              '-'
                            : recruitmentPolicyChange?.recruitmentDataControllerContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    recruitmentPolicyChange?.recruitmentDataProtectionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentPolicyChange?.recruitmentDataProtectionTitleTh
                            : recruitmentPolicyChange?.recruitmentDataProtectionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    recruitmentPolicyChange?.recruitmentDataProtectionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? recruitmentPolicyChange?.recruitmentDataProtectionContentTh ||
                              '-'
                            : recruitmentPolicyChange?.recruitmentDataProtectionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>${lang === 'TH' ? 'ฉบับ ณ วันที่' : 'Edition as of'}&nbsp;&nbsp;
                ${getCurrentDate(recruitmentPrivacyPolicy?.effectiveDate)}</h4>
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${
                    lang === 'TH'
                        ? recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyNameTh +
                          `${date}TH.docx`
                        : recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyNameEn +
                          `${date}EN.docx`
                }');
                setTimeout(()=> window.close(), 100)
                });
        </script>
            </body>
    `;

    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
            ${body}
        </html>`,
        body,
    };
}
